import { CHANGE_UPLOAD_STATUS, ADD_UPLOAD_ITEM, CLEAR_UPLOAD } from '../constants/ActionTypes';

const defaultState = { list: [] };

const uploadReducer = (state = defaultState, { type, payload = { uid: '', asyncStatus: '' } } ) => {
  switch(type) {
    // 将socket推送的图片状态，更新到对应的图片上
    case CHANGE_UPLOAD_STATUS:
      return {
        ...state,
        list: state.list.map(item => {
          if (item.uid === payload.uid) {
            return {
              ...item,
              uid: payload.uid,
              asyncStatus: payload.asyncStatus
            }
          }
          return item;
        })
      }
      // 增加上传项
    case ADD_UPLOAD_ITEM:
      return {
        ...state,
        list: [...state.list, payload]
      }
    case CLEAR_UPLOAD:
      return {
        ...state,
        list: []
      }
    default: 
      return state
  }
}

export default uploadReducer;